var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-9"},[_c('h1',{staticClass:"fs-21 mb-3"},[_vm._v(_vm._s(_vm.$t('all_coupons')))]),_c('v-row',{staticClass:"row-cols-1 row-cols-sm-2 row-cols-lg-3"},_vm._l((_vm.coupons),function(coupon,i){return _c('v-col',{key:i},[_c('coupon-box',{attrs:{"is-loading":_vm.loading,"coupon-details":coupon}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }